import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import userPermissionsService from '../../api/userPermissionsService'

const initialState = {
  userPermissions: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: '',
}

// Fetch user permissions by database name
export const fetchUserPermissions = createAsyncThunk(
  'userPermissions/fetchAll',
  async (databaseName, thunkAPI) => {
    try {
      return await userPermissionsService.getUserPermissions(databaseName)
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const userPermissionsSlice = createSlice({
  name: 'userPermissions',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
    },
    clearUserPermissions: (state) => {
      state.userPermissions = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissions.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.userPermissions = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(fetchUserPermissions.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset, clearUserPermissions } = userPermissionsSlice.actions
export default userPermissionsSlice.reducer
